import React from 'react';
export function Footer() {
  return <footer className="bg-darker py-8 border-t border-gray-900 text-center px-4" data-id="element-56">
      <p className="text-gray-500 text-sm mb-2" data-id="element-57">
        © {new Date().getFullYear()} Escalada Pro System. Todos los derechos
        reservados.
      </p>
      <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-58">
        Este sitio no es parte del sitio web de Facebook o Facebook Inc. Además,
        este sitio NO está respaldado por Facebook de ninguna manera. FACEBOOK
        es una marca registrada de FACEBOOK, Inc.
      </p>
    </footer>;
}